import { useCallback, useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "../../utils/const";
import { styles } from "./icons_section";
import { useI18n } from "@/i18n/I18nProvider";
import Title from "../../components/mini-components/Title.jsx";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { setOptionId } from "../../Redux/store";

export default function IconsSection({ homeServices = [] ,servicesTitle}) {
  const { t, locale } = useI18n();
  const dispatch = useDispatch();

  const substring = useMemo(
    () => (locale === "en" ? "Kol Yom" : "كل يوم"),
    [locale],
  );

  const renderString = useCallback(
    (text) => {
      const lower = text?.toLowerCase?.() ?? "";
      const idx = lower.indexOf(substring.toLowerCase());

      if (idx === -1) {
        return <>{text}</>;
      }

      return (
        <>
          {text.substring(0, idx)}
          <strong>{text.substring(idx, idx + substring.length)}</strong>
          {text.substring(idx + substring.length)}
        </>
      );
    },
    [substring],
  );

  const scrollToProducts = useCallback(() => {
    const el = document.getElementById("all-products");
    el?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <>
      <Box className="horizontal-safe-padding mt-5">
      <Title h2="h2" title={servicesTitle} />
      </Box>

      {/* Container واحد فقط */}
      <Box
        sx={styles.container}
        className="horizontal-safe-padding vertical-safe-padding mb-5"
      >
        {/* {t.featureSection.map((item, index) => { */}
        {homeServices.map((item, index) => {
          const isFirst = index === 0;
          const isSecond = index === 1;
          const isLast = index === t.featureSection.length - 1;

          // Component موحد للكارد
          const CardContent = (
            <Box
              sx={styles.item}
              data-aos="fade-up"
              data-aos-delay={item.delay}
            >
              <Box
                component="img"
                src={item.icon}
                alt={item.alt_icon}
                sx={{ height: { xs: 65, md: 80 }, width: { xs: 65, md: 80 } }}
                loading="lazy"
              />

              <Typography
                // component="h3"
                  variant={item.title.type}
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: { xs: "18px", md: "27px" }, 
                  fontWeight: "bold",
                  color: colors.blue,
                  m: 0,
                }}
              >
                {locale === "en" ? item.title.text.en : item.title.text.ar}{" "}
              </Typography>

              <Typography
                component="p"
                sx={{
                  wordWrap: "break-word",
                  textAlign: "center",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  color: colors.petroli,
                  m: 0,
                }}
              >
                {renderString(
                  locale === "en"
                    ? item.description.text.en
                    : item.description.text.ar,
                )}{" "}
              </Typography>
            </Box>
          );

          // أول كارد: scroll
          if (isFirst) {
            return (
              <Box
                key={item.id}
                component="button"
                type="button"
                onClick={scrollToProducts}
                sx={{
                  ...styles.cardWrapper,
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  textAlign: "inherit",
                }}
              >
                {CardContent}
              </Box>
            );
          }

          // تاني كارد: scroll + setOptionId
          if (isSecond) {
            return (
              <Box
                key={item.id}
                component="button"
                type="button"
                onClick={() => {
                  scrollToProducts();
                  dispatch(setOptionId("3"));
                }}
                sx={{
                  ...styles.cardWrapper,
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  textAlign: "inherit",
                }}
              >
                {CardContent}
              </Box>
            );
          }

          // آخر كارد: Link
          if (isLast) {
            return (
              <Link
                key={item.id}
                href="/products/contact-now"
                style={{ textDecoration: "none", color: "inherit" }}
                // prefetch={false}
              >
                <Box sx={styles.cardWrapper}>{CardContent}</Box>
              </Link>
            );
          }

          // باقي الكروت: غير clickable
          return (
            <Box key={item.id} sx={styles.cardWrapper}>
              {CardContent}
            </Box>
          );
        })}
      </Box>
    </>
  );
}
